import { Box } from "@chakra-ui/react"

import { HeadSkeleton, TableSkeleton } from 'View/report-attendance-operator/component/skeleton'

import styles from './styles.module.css'

const ReportAttendanceOperatorSkeleton = () => {
    return (
        <Box className={styles['skeleton__container']}>
            <Box className={styles['skeleton__head--container']}>
                <HeadSkeleton />
            </Box>
            <Box className={styles['skeleton__table--container']}>
                <TableSkeleton />
            </Box>
        </Box>
    )

}

export default ReportAttendanceOperatorSkeleton